module.exports = __webpack_public_path__ + "img/youtube.916828fa.png";